import { Link } from 'react-router-dom';
import { ColorSchemePicker } from './ColorSchemeProvider';
import UserProfileDropdown from './UserProfileDropdown';

interface HeaderProps {
  isAuthenticated: boolean;
  onLogout?: () => void;
  userEmail?: string;
  userName?: string;
  avatarUrl?: string;
}

function Header({ isAuthenticated, onLogout, userEmail, userName, avatarUrl }: HeaderProps) {
  return (
    <header
      className="text-white shadow-sm border-b border-gray-800"
      // Inline style guarantees the exact same background color as the
      // sidebar regardless of any stale Tailwind JIT output or theme
      // override. Tailwind `gray-900` = #111827.
      style={{ backgroundColor: '#111827' }}
    >
      {/* Full-width content row. Previously wrapped in `max-w-7xl mx-auto`
          which pushed the logo ~100px off the left edge on wide monitors —
          the header now spans the viewport so the logo aligns with the
          sidebar underneath. Minimal padding to keep logo flush-left. */}
      <div className="px-3">
        <div className="flex justify-between items-center h-16">
          {/* Logo Section */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/colliers-logo.svg" alt="Colliers" className="h-8" />
              <span className="ml-2 text-xl font-semibold text-white">Idaho Intelligence</span>
            </Link>
          </div>

          {/* Auth Section */}
          <div className="flex items-center space-x-4">
            <ColorSchemePicker />
            {isAuthenticated ? (
              <UserProfileDropdown
                onLogout={onLogout || (() => {})}
                userEmail={userEmail}
                userName={userName}
                avatarUrl={avatarUrl}
              />
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-sm font-medium text-gray-200 hover:text-white px-4 py-2 rounded-md hover:bg-gray-800 transition-colors"
                >
                  Login
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;